import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { loadModules } from 'esri-loader';
import { BehaviorSubject } from 'rxjs';
import { LibModuleOptions, MOL_LIB_TOKEN } from '../lib.config';
import {
  KetQuaTraCuu,
  ThongTinQuyHoach,
  ToaDo,
  ResThongTinQuyHoach,
  QueryThuaDat,
} from '../models/thongtinquyhoach.model';

const COLORS = [
  [179, 57, 57, 0.8],
  [33, 140, 116, 0.8],
  [51, 217, 178, 0.8],
  [255, 121, 63, 0.8],
  [241, 196, 15, 0.8],
  [142, 68, 173, 0.8],
  [243, 156, 18, 0.8],
  [52, 152, 219, 0.8],
  [254, 218, 222, 0.8],
  [67, 237, 202, 0.8],
  [1, 185, 245, 0.8],
  [255, 106, 108, 0.8],
  [250, 209, 93, 0.8],
  [79, 158, 48, 0.8],
  [153, 137, 166, 0.8],
  [221, 252, 173, 0.8],
  [146, 163, 99, 0.8],
  [23, 126, 137, 0.8],
  [8, 76, 97, 0.8],
  [187, 10, 30, 0.8],
  [255, 200, 87, 0.8],
  [171, 150, 121, 0.8],
  [0, 128, 0, 0.8],
  [6, 81, 67, 0.8],
  [4, 150, 255, 0.8],
  [255, 16, 83, 0.8],
  [18, 148, 144, 0.8],
];
@Injectable({
  providedIn: 'root',
})
export class ThongTinQuyHoachService {
  private geometryService: __esri.GeometryService;
  private graphicsLayer: __esri.GraphicsLayer;

  public URL: string;
  private _view: __esri.MapView;
  get view() {
    return this._view;
  }
  set view(view) {
    this._view = view;
    if (!this.graphicsLayer) {
      type MapModule = [typeof import('esri/layers/GraphicsLayer')];
      (loadModules(['esri/layers/GraphicsLayer']) as Promise<MapModule>).then(
        ([GraphicsLayer]) => {
          this.graphicsLayer = new GraphicsLayer({ listMode: 'hide' });
          this.view.map.add(this.graphicsLayer);
        }
      );
    }
  }
  private dataSource = new BehaviorSubject<KetQuaTraCuu | null>(null);
  data$ = this.dataSource.asObservable();

  constructor(
    private http: HttpClient,
    @Inject(MOL_LIB_TOKEN) private option: LibModuleOptions
  ) {
    this.URL = this.option.apiUrl + '/thong-tin-quy-hoach';
    type MapModule = [typeof import('esri/tasks/GeometryService')];
    (loadModules(['esri/tasks/GeometryService']) as Promise<MapModule>).then(
      ([GeometryService]) => {
        this.geometryService = new GeometryService({
          url: this.option.map.geometryService,
        });
      }
    );
  }

  close() {
    this.dataSource.next(null);
    // tslint:disable-next-line: no-unused-expression
    this.graphicsLayer && this.graphicsLayer.removeAll();
  }

  /**
   * lấy thông tin quy hoạch theo số tờ số thửa  hoặc objectId
   */
  public async layThongTinQuyHoach(params: {
    thuaDat?: QueryThuaDat;
    point?: __esri.Point;
    paths?: number[][];
  }): Promise<KetQuaTraCuu> {
    let result: ResThongTinQuyHoach;
    try {
      const {point,thuaDat,paths}=params;
      if (point) {
        result = await this.getThongTinQuyHoachTheoXY(params.point);
      } else if (
        thuaDat
      ) {
        const { soTo, soThua, maQuanHuyen, maPhuongXa } = params.thuaDat;
        if(soTo && soThua && maQuanHuyen &&maPhuongXa)
        result = await this.getThongTinQuyHoachTheoThuaDat({
          soThua,
          soTo,
          maPhuongXa,
          maQuanHuyen,
        });
      } else if (paths) {
        result = await this.getThongTinQuyHoachTheoPaths({
          paths: paths,
        });
      }
    } catch ({ error }) {
      throw new Error(error.message);
    }

    const model: KetQuaTraCuu = {
      thuaDat: result.thuaDat,
      thongTinThuaDats: result.thongTinThuaDats,
    };
    this.dataSource.next(model);
    const { thongTinThuaDats, graphics } = await this.hienThiThongTinThuaDat(
      model.thongTinThuaDats
    );
    type MapModule = [typeof import('esri/geometry/geometryEngine')];
    const [geometryEngine] = await (loadModules([
      'esri/geometry/geometryEngine',
    ]) as Promise<MapModule>);
    this.dataSource.next({
      ...model,
      thongTinThuaDats,
      geometry: geometryEngine.union(
        graphics.map((m) => m.geometry)
      ) as __esri.Polygon,
    });
    this.view.goTo(this.dataSource.value.geometry)
    return model;
  }

  /**
   * lấy thông tin của thửa đất
   */
  public getThongTinQuyHoachTheoPaths(params: { paths: Array<Array<number>> }) {
    return this.http
      .post<ResThongTinQuyHoach>(
        this.URL+'/paths',
        JSON.stringify({
          paths: params.paths,
        }),
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      )
      .toPromise();
  }
  public getThongTinQuyHoachTheoXY(params: { x: number; y: number }) {
    return this.http
      .get<ResThongTinQuyHoach>(this.URL + '/xy', {
        params: {
          x: params.x + '',
          y: params.y + '',
          // maQuanHuyen
        },
      })
      .toPromise();
  }
  public getThongTinQuyHoachTheoThuaDat(params: {
    maQuanHuyen: string;
    maPhuongXa: string;
    soTo: string;
    soThua: string;
  }) {
    // const {maQuanHuyen,maPhuongXa,soTo,soThua}=params;
    return this.http
      .get<ResThongTinQuyHoach>(this.URL + '/thuadat', {
        params,
      })
      .toPromise();
  }

  async hienThiThongTinThuaDat(pThongTinThuaDats: ThongTinQuyHoach[]) {
    // nếu chưa tạo graphics
    this.graphicsLayer.removeAll();

    const thongTinThuaDats = [...pThongTinThuaDats];

    // gán màu & chuyển tọa độ > arcgis js polygon
    let index = 0;
    const lstGraphicSuDungDat: Array<__esri.Graphic> = [];
    type MapModule = [
      typeof import('esri/Graphic'),
      typeof import('esri/geometry/Polygon'),
      typeof import('esri/geometry/SpatialReference')
    ];
    const [Graphic, Polygon, SpatialReference] = await (loadModules([
      'esri/Graphic',
      'esri/geometry/Polygon',
      'esri/geometry/SpatialReference',
    ]) as Promise<MapModule>);
    if (thongTinThuaDats.length > 0) {
      thongTinThuaDats.forEach((thongTinThuaDat) =>
        thongTinThuaDat.doAns.forEach((doAn) => {
          doAn.phanKhuChucNangs.forEach((phanKhuChucNang) => {
            phanKhuChucNang.shape = new Polygon({
              ...phanKhuChucNang.shape,
              spatialReference: SpatialReference.WebMercator,
            });
            phanKhuChucNang.color = COLORS[index];
            const graphic: __esri.Graphic = new Graphic({
              geometry: phanKhuChucNang.shape,
              attributes: { color: phanKhuChucNang.color },
              symbol: {
                type: 'simple-fill',
                color: phanKhuChucNang.color,
                outline: {
                  color: [255, 255, 255],
                  width: 1,
                },
              } as any,
            });
            lstGraphicSuDungDat.push(graphic);
            index++;
          });
        })
      );

      // tạo đối tượng graphic từ polygon và color để hiển thị trên bản đồ & goto
      this.graphicsLayer.addMany(lstGraphicSuDungDat);
      this.view.goTo(lstGraphicSuDungDat);
    }
    return { thongTinThuaDats, graphics: lstGraphicSuDungDat };
  }

  private projectGeometry = async (toaDos: ToaDo[]) => {
    const paths: Array<Array<number>> = [];
    toaDos.forEach((toaDo) => {
      if (toaDo.toaDoX && toaDo.toaDoY) {
        paths.push([toaDo.toaDoY, toaDo.toaDoX]);
      }
    });
    let geometry: __esri.Geometry | null = null;
    type MapModule = [
      typeof import('esri/geometry/Point'),
      typeof import('esri/geometry/Polyline'),
      typeof import('esri/geometry/Polygon'),
      typeof import('esri/tasks/support/ProjectParameters')
    ];
    const [Point, Polyline, Polygon, ProjectParameters] = await (loadModules([
      'esri/geometry/Point',
      'esri/geometry/Polyline',
      'esri/geometry/Polygon',
      'esri/tasks/support/ProjectParameters',
    ]) as Promise<MapModule>);
    if (paths.length === 1) {
      geometry = new Point({ x: paths[0][1], y: paths[0][0] });
    } else if (paths.length === 2) {
      geometry = new Polyline({ paths: [paths] });
    } else if (paths.length > 2) {
      geometry = new Polygon({ rings: [paths] });
    }
    if (geometry) {
      // geometry.spatialReference = this.;
      const result = await this.geometryService.project(
        new ProjectParameters({
          outSpatialReference: this.view.spatialReference,
          geometries: [geometry],
        })
      );
      return result.length > 0 ? result[0] : null;
    }
    return null;
  };

  async drawGraphicByCoords(params: { toaDos: ToaDo[] }) {
    this.graphicsLayer.removeAll(); // clear graphics để vẽ lại
    const { toaDos } = params;
    const pathLength = toaDos.filter(
      (toaDo) => toaDo.toaDoX && toaDo.toaDoY
    ).length;
    let symbol: __esri.Symbol | null = null;
    type MapModule = [
      typeof import('esri/symbols/SimpleMarkerSymbol'),
      typeof import('esri/symbols/SimpleLineSymbol'),
      typeof import('esri/symbols/SimpleFillSymbol')
    ];
    const [SimpleMarkerSymbol, SimpleLineSymbol, SimpleFillSymbol] =
      await (loadModules([
        'esri/symbols/SimpleMarkerSymbol',
        'esri/symbols/SimpleLineSymbol',
        'esri/symbols/SimpleFillSymbol',
      ]) as Promise<MapModule>);
    if (pathLength === 1) {
      symbol = symbol = new SimpleMarkerSymbol({
        color: [0, 255, 255],
        size: 3,
      });
    } else if (pathLength === 2) {
      symbol = new SimpleLineSymbol({
        color: [0, 255, 255],
        width: 4,
      });
    } else if (pathLength > 2) {
      symbol = new SimpleFillSymbol({
        outline: {
          color: [0, 255, 255],
          width: 1,
        },
      });
    }

    this.projectGeometry(toaDos).then((geometry) => {
      if (geometry) {
        this.graphicsLayer.add({ geometry, symbol } as __esri.Graphic);
        this.view.goTo(geometry);
      }
    });
  }
  async getCoordFromShortUrl(shortUrl: string) {
    const { longitude, latitude } = await this.http
      .get<__esri.Point>(this.URL + '/GetCoordFromGMapShortUrl?url=' + shortUrl)
      .toPromise();
    type MapModule = [
      typeof import('esri/geometry/Point'),
      typeof import('esri/geometry/SpatialReference')
    ];
    const [Point, SpatialReference] = await (loadModules([
      'esri/geometry/Point',
      'esri/geometry/SpatialReference',
    ]) as Promise<MapModule>);
    const wgs84Point = new Point({
      longitude,
      latitude,
      spatialReference: SpatialReference.WebMercator,
    });
    return wgs84Point;
  }
}
